import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
} from '@angular/core';
import { UpgraderService } from '../upgrader.service';
import { SessionService } from '@core/services/session.service';
import { FormsModule } from '@angular/forms';
import { GameIconComponent } from '../../../core/components/game-icon/game-icon.component';
import { InputOptionsComponent } from '../../../core/components/input-options/input-options.component';
import { FairnessButtonComponent } from '../../../core/components/fairness-button/fairness-button.component';
import { BalanceIconComponent } from '../../../core/components/balance-icon/balance-icon.component';
import { ClipboardService } from '@core/services/clipboard.service';
import { OldSliderComponent } from '@core/components/old-slider/old-slider.component';
import { fadeInAnimation } from '@core/utils/animations.util';

@Component({
  selector: 'app-upgrader-bet-section',
  templateUrl: './upgrader-bet-section.component.html',
  styleUrls: ['./upgrader-bet-section.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    GameIconComponent,
    InputOptionsComponent,
    FairnessButtonComponent,
    BalanceIconComponent,
    OldSliderComponent,
  ],
  host: {
    class: 'box-black-third rounded-6',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInAnimation],
})
export class UpgraderBetSectionComponent {
  public upgraderService = inject(UpgraderService);
  public sessionService = inject(SessionService);
  public clipboardService = inject(ClipboardService);

  betInputOptions = [
    {
      label: '1/2',
      fn: () => this.onHalf(),
    },
    {
      label: '2x',
      fn: () => this.onDouble(),
    },
    {
      label: 'Max',
      fn: () => this.onMax(),
    },
  ];

  betButtons = [
    {
      label: '+1',
      fn: () => this.addValue(1),
    },
    {
      label: '+10',
      fn: () => this.addValue(10),
    },
    {
      label: '+25',
      fn: () => this.addValue(25),
    },
    {
      label: '+100',
      fn: () => this.addValue(100),
    },
  ];

  isDisabledPanel = computed(() => {
    return this.upgraderService.selectedSkinsS().length === 0;
  });

  inputResetEffect = effect(() => {
    if (this.isDisabledPanel() && this.upgraderService.betAmount() > 0) {
      this.upgraderService.setBetAmount(0);
    }
  });

  onHalf() {
    this.upgraderService.setBetAmount(this.upgraderService.betAmount() / 2);
  }

  onDouble() {
    this.upgraderService.setBetAmount(this.upgraderService.betAmount() * 2);
  }

  onMax() {
    this.upgraderService.setBetAmount(this.upgraderService.maxBetAmount());
  }

  addValue(val: number) {
    this.upgraderService.setBetAmount(this.upgraderService.betAmount() + val);
  }
}
